/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ApiResponseDailyRecommendation } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface RecommendationV2ServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * 
     * 
     * @param date 
     */
    recommendationV2ControllerGet0(date: string, extraHttpRequestParams?: any): Observable<ApiResponseDailyRecommendation>;

    /**
     * 
     * 
     * @param date 
     */
    recommendationV2ControllerGet1(date: string, extraHttpRequestParams?: any): Observable<ApiResponseDailyRecommendation>;

}
